import { FeatureFlag } from 'constant/featureFlag'
import { ClientType, ItemType, OperationalSettingContract } from 'models'
import React from 'react'
import nameof from 'utilities/nameof'

const fields = nameof<OperationalSettingContract>()

export interface ITab {
    label: string | React.ReactNode
    href: string
    requireModulePermission?: number[]
}
export interface ITabComponent {
    id?: string
    label: string | React.ReactNode
    showError?: boolean
    component: React.ReactNode
    disabled?: boolean
    isZeroPadding?: boolean
}
/** specific module that has enable/disable setting */
const moduleArr = [
    fields.quickSales,
    fields.tableSales,
    fields.onlineSales,
    fields.timeClock,
    fields.orderDashboard,
    fields.kds,
    fields.loyalty,
    fields.giftCard,
    fields.customerFacingDisplay,
]
export type ModuleNames = typeof moduleArr[number]

const posTerminalOperation = [
    'openTerminal',
    'cashPayin',
    'cashPayout',
    'cashDeposit',
    'closeTerminal',
]

export type TerminalOperationSetting = typeof posTerminalOperation[number]

export interface IRoute {
    path: string
    component?: any
    exact?: boolean
    requirePermission: number[]
    moduleName?: ModuleNames
    terminalSetting?: TerminalOperationSetting
    visibleToClientType?: ClientType[]
    redirectToPath?: string
    featureFlags?: FeatureFlag[]
}
export interface ILinkTab extends IRoute {
    label?: string
}
export interface IPosTerminalOpenAmount {
    amount: number
    note: string
}

export interface IOption {
    label: string
    value: any
}

export interface IAppErrorResponse {
    message: string
    status: number
    additionValue: any
    errorType: string
}

export interface ItemAvailabilityChangeContract {
    itemID: string
    type: ItemType
    refCode: string
    isTrackInventory: boolean
    isOutOfStock: boolean
    isAvailableToSelect: boolean
}
export interface TableReservationContract {
    TableReservationID: string
    TableID: string
    TableGroupID?: string
    StartReservedOn: string
    EndReservedOn?: string
    CustomerID?: string
    EmployeeUserID: string
    ClientID: string
    IsCancelled: boolean
    TenantIdentifierID?: string
}
export enum EnumRegisterStatus {
    InProgress = 'in-progress',
    Completed = 'completed',
    Error = 'error',
    NotFound = 'not found',
}
